module.exports = __webpack_public_path__ + "static/media/shoucangBuss.9e289872.svg";